import { Col, Form, Row } from 'antd';
import PropTypes from 'prop-types';
import { ActionsEditSummaryItem } from './ActionsEditSummaryItem';
import { TitleSummary } from '../../../style';

export const FormEditSummaryItem = ({ field, onFinish, children, showActionsInTitle, fullWidthInput = false }) => {
  const [form] = Form.useForm();

  const handleSave = () => {
    const newValue = form.getFieldValue(field.idInput);
    onFinish({
      save: true,
      newValue: { value: newValue },
    });
  };

  const handleCancel = () => {
    onFinish();
  };

  const renderActions = () => {
    return <ActionsEditSummaryItem handleCancel={handleCancel} handleSave={handleSave} />;
  };

  return (
    <Form form={form} name={field.idInput} layout="vertical">
      <Row>
        <TitleSummary>{field.label} </TitleSummary> {showActionsInTitle ? renderActions() : null}
      </Row>
      <Row>
        <Col md={fullWidthInput ? 24 : 16}>
          <Form.Item name={field.idInput} initialValue={field.value}>
            {children}
          </Form.Item>
        </Col>
        {!showActionsInTitle ? (
          <Col md={6}>
            <div style={{ marginTop: '9px' }}>{renderActions()}</div>
          </Col>
        ) : null}
      </Row>
    </Form>
  );
};

FormEditSummaryItem.propTypes = {
  field: PropTypes.object,
  onFinish: PropTypes.func,
  children: PropTypes.node,
  showActionsInTitle: PropTypes.bool,
  fullWidthInput: PropTypes.bool,
};
